import React from 'react';
import { useParams } from 'react-router-dom';
import { Tab } from '@mui/material';
import ScrollableTabs from 'components/shared/ScrollableTabs';
import CustomTabPanel from './TabPanel';
import CounselorCollegeSearch from './CounselorCollegeSearch';
import CounselorCollegeView from './CounselorCollegeView';
const RCollege = ({ setCurrentModuleId }: { setCurrentModuleId: (id: string) => void }) => {
  const params: { id?: string | number } = useParams();

  React.useEffect(() => {
    const getData = async () => {
      // const res: any = await activitiesAndHonorsServices.getAdditionalInfo(params.id);
      // setMyAdditionalInfo(res);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  const [value, setValue] = React.useState(1);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`8.${newValue}`);
  };
  return (
    <div>
      <ScrollableTabs
        className='mt-2'
        value={value}
        onChange={handleChange}
        variant="scrollable"
        sx={{
          position: 'sticky',
          top: '72px',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab value={1} label="College Search" />
        <Tab value={2} label="College List" />
      </ScrollableTabs>
      <CustomTabPanel value={value} index={1}>
        <CounselorCollegeSearch />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <CounselorCollegeView />
      </CustomTabPanel>
    </div>
  );
};

export default RCollege;
